export default __webpack_public_path__ + "static/media/duck_thumb.66c640ad.jpg";